"use client";

import { useEffect } from "react";

const Error = ({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useEffect(() => {
    if ((window as any).newrelic) {
      (window as any).newrelic.noticeError(error);
    }
    console.error("[ErrorBoundary]", error);
  }, [error]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        padding: "2rem",
        textAlign: "center",
        fontFamily:
          'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <h2
        style={{
          fontSize: "1.5rem",
          fontWeight: 600,
          // Theme-aware via the shared token var (dark navy in light, white in
          // dark) so the heading stays visible on the dark body background.
          color: "rgb(var(--color-secondary-1, 5 0 78))",
          marginBottom: "0.75rem",
        }}
      >
        Something went wrong
      </h2>
      <p
        style={{
          fontSize: "0.9rem",
          color: "#6b7280",
          marginBottom: "1.5rem",
          maxWidth: "400px",
        }}
      >
        An unexpected error occurred. This may be a temporary issue — please try
        again.
      </p>
      <div style={{ display: "flex", gap: "0.75rem" }}>
        <button
          onClick={() => reset()}
          style={{
            padding: "0.625rem 1.5rem",
            fontSize: "0.875rem",
            fontWeight: 600,
            color: "#fff",
            backgroundColor: "rgb(var(--color-primary, 51 109 255))",
            border: "none",
            borderRadius: "0.75rem",
            cursor: "pointer",
            transition: "opacity 0.2s",
          }}
          onMouseOver={(e) =>
            ((e.target as HTMLElement).style.opacity = "0.85")
          }
          onMouseOut={(e) => ((e.target as HTMLElement).style.opacity = "1")}
        >
          Try again
        </button>
        <button
          onClick={() => (window.location.href = "/")}
          style={{
            padding: "0.625rem 1.5rem",
            fontSize: "0.875rem",
            fontWeight: 600,
            color: "#374151",
            backgroundColor: "#f3f4f6",
            border: "1px solid #e5e7eb",
            borderRadius: "0.75rem",
            cursor: "pointer",
            transition: "opacity 0.2s",
          }}
          onMouseOver={(e) =>
            ((e.target as HTMLElement).style.opacity = "0.85")
          }
          onMouseOut={(e) => ((e.target as HTMLElement).style.opacity = "1")}
        >
          Go home
        </button>
      </div>
    </div>
  );
};

export default Error;
